import { postFetch } from '../fetch';

const URL = '/turing-api/subscriptions';

type Subscription =
    | 'yau_ege'
    | 'yateachers'
    | 'kryau'
    | 'yau_newprod'
    | 'yautpromo';

type Subscriptions = Record<Subscription, boolean>;

export function postNewSubscriptions(subscriptions: Subscriptions): Promise<void> {
    return postFetch(URL, subscriptions);
}
